"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaErrorLookUp = void 0;
const utils_1 = require("../utils");
const schemaErrorLookUp = (values, validationSchema = {}) => {
    const errors = {};
    Object.entries(validationSchema).forEach(([fieldName, validationRule]) => {
        const value = values[fieldName];
        errors[fieldName] = (0, utils_1.validate)(validationRule, value, fieldName, values);
    });
    return errors;
};
exports.schemaErrorLookUp = schemaErrorLookUp;
//# sourceMappingURL=schemaErrorLookup.js.map